import { useMemo } from "react";
import { checkAndValidateStoredDates } from "@/utils";
import { DEFAULT_CHECKIN_DATE, DEFAULT_CHECKOUT_DATE } from "@/constants";

/**
 * Custom hook to validate and return stored check-in/check-out dates with fallback to defaults.
 * @param checkIn - Stored check-in date (string | Date | null | undefined)
 * @param checkOut - Stored check-out date (string | Date | null | undefined)
 * @returns { checkIn: Date, checkOut: Date } - Validated dates
 */
export const useValidatedDates = (
  checkIn: string | Date | null | undefined,
  checkOut: string | Date | null | undefined,
) => {
  return useMemo(() => {
    return checkAndValidateStoredDates(
      checkIn,
      DEFAULT_CHECKIN_DATE,
      checkOut,
      DEFAULT_CHECKOUT_DATE,
    );
  }, [checkIn, checkOut]);
};
